import React from 'react'
import { Routes, Route } from "react-router-dom";
import Dashboard from './components/Dashboard';

const AppRouter = () => {
    return (
        <Routes>
            <Route
                exact
                path="/dashboard"
                element={<Dashboard />}
                // loader={async ({ request, params }) => {
                //     console.log(request)
                //     console.log(params)
                //     return fetch(
                //         `/fake/api/teams/${params.teamId}.json`,
                //         { signal: request.signal }
                //     )
                // }}
                // action={async ({ request }) => {
                //     console.log(request)

                // }}
                // errorElement={<div>Error page</div>}
            />
        </Routes>
    )
}

export default AppRouter